module.exports = __webpack_public_path__ + "static/media/3ll21.da2d8049.png";